import gsap from "gsap";
import EventDispatcher from "../common/EventDispatcher";
import { Global } from "../common/global";
import { shuffle } from "../common/array-util";

export default class Result {
  constructor() {
    document
      .querySelector("#scoreScr #tryAgain")
      .addEventListener("click", this.replayGame.bind(this));

    document
      .querySelector("#scoreScr #startNext")
      .addEventListener("click", this.onStartNext.bind(this));
    document
      .querySelector("#scoreScr #shareButton")
      .addEventListener("click", this.shareThumbnail.bind(this));
  }
  init() {
    this.screenActive = false;
    this.events = EventDispatcher.getObj();
    this.events.addEventListener("GAMESCENE_EVENTS", this.onEvents.bind(this));
  }
  onEvents(data) {
    switch (data["message"]["event_type"]) {
      case "show_screen":
        this.showScreen(data["message"]["data"]);
        break;
    }
  }
  showScreen(data) {
    if (data["screenKey"] !== "Result") return false;

    this.screenActive = true;
    document.querySelector("#scoreScr").classList.add("active");
    document.querySelector("#scoreScr").classList.add("active2");

    // if (Global.collectedTotal < 8 /* Global.totalToCollect */) {
    //   document
    //     .querySelector("#scoreScr #startNext_container")
    //     .classList.remove(`active`);
    //   // document
    //   //   .querySelector("#scoreScr #share_container")
    //   //   .classList.remove(`active`);
    // } else {
    //   document
    //     .querySelector("#scoreScr #startNext_container")
    //     .classList.add(`active`);

    //   // document
    //   //   .querySelector("#scoreScr #share_container")
    //   //   .classList.add(`active`);

    //   // console.log("Share button shown11");
    // }

    // document
    //   .querySelector("#scoreScr #tryAgain_container")
    //   .classList.add(`active`);

    if (Global.collectedTotal > 9) {
      document
        .querySelector("#scoreScr #tryAgain_container")
        .classList.remove(`active`);
      document
        .querySelector("#scoreScr #startNext_container")
        .classList.add(`active`);
    } else if (Global.collectedTotal >= 8 && Global.collectedTotal <= 9) {
      document
        .querySelector("#scoreScr #tryAgain_container")
        .classList.add(`active`);
      document
        .querySelector("#scoreScr #startNext_container")
        .classList.add(`active`);
    } else {
      document
        .querySelector("#scoreScr #tryAgain_container")
        .classList.add(`active`);
      document
        .querySelector("#scoreScr #startNext_container")
        .classList.remove(`active`);
    }

    if (Global.collectedTotal >= 10 /* Global.totalToCollect */) {
      document.querySelector("#scoreScr .bottom .title span").innerText =
        `आपने सभी ज़रूरी सामान अपने किट में पैक कर लिया है और अब आप डिप्लॉय होने के लिए तैयार हैं.`;
      document.querySelector("#scoreScr .bottom .desc span").innerText = "";
    } else {
      document.querySelector("#scoreScr .bottom .title span").innerText =
        `समय समाप्त!`;
      document.querySelector(
        "#scoreScr .bottom .desc span",
        // ).innerText = `आपने ${Global.collectedTotal} में से ${Global.totalToCollect} आइटम्स इकट्ठा किए\nआपकी किट में कुछ और ज़रूरी सामान पैक करना रह गया है.`;
      ).innerText =
        `आपने ${Global.totalToCollect} में से ${Global.collectedTotal} आइटम्स इकट्ठा किए.\n आपकी किट में कुछ और ज़रूरी सामान पैक करना रह गया है.`;
    }
    this.titleIndex = -10;
    this.titleInt = setInterval(() => {
      if (this.titleIndex < 18) {
        document
          .querySelector("#scoreScr .title")
          .classList.remove(`title${this.titleIndex}`);
      }

      this.titleIndex++;
      if (this.titleIndex > 18) {
        document.querySelector("#scoreScr .logo").classList.add(`active`);
        document
          .querySelector("#scoreScr .bottom .title")
          .classList.add(`active`);
        document
          .querySelector("#scoreScr .bottom .desc")
          .classList.add(`active`);

        setTimeout(() => {
          if (Global.collectedTotal > 9) {
            document
              .querySelector("#scoreScr #startNext")
              .classList.add(`active`);

            // .querySelector("#scoreScr #shareButton")
            // .classList.add(`active`);
            // console.log("Share button shown12");
          } else if (Global.collectedTotal >= 8 && Global.collectedTotal <= 9) {
            document
              .querySelector("#scoreScr #startNext")
              .classList.add(`active`);

            document
              .querySelector("#scoreScr #tryAgain")
              .classList.add(`active`);

            // .querySelector("#scoreScr #shareButton")
            // .classList.add(`active`);
            // console.log("Share button shown12");
          } else {
            // document
            //   .querySelector('#scoreScr #startNext')
            //   .classList.remove(`active`);
            document
              .querySelector("#scoreScr #tryAgain")
              .classList.add(`active`);
            // document
            //   .querySelector("#scoreScr #shareButton")
            //   .classList.remove(`active`);
          }
        }, 0);

        clearInterval(this.titleInt);
      } else {
        document
          .querySelector("#scoreScr .title")
          .classList.add(`title${this.titleIndex}`);
      }
    }, 30);
  }
  animateScreen() {}

  hideScreen() {
    if (!this.screenActive) return;
    this.screenActive = false;
    document.querySelector("#scoreScr").classList.remove("active");
    // document.querySelector('#homeScr').classList.remove('active2');
  }
  onStartNext() {
    Global.serverObj.send(Global.URL_VUPDATE, null, null, {
      saveType: "360scoreNextClick",
      uniqID: Global.U_ID,
    });
    this.hideScreen();

    this.events.dispatchEvent({
      type: "GAMESCENE_EVENTS",
      message: {
        event_type: "show_screen",
        data: {
          screenKey: "QuizHome",
        },
      },
    });
  }
  replayGame() {
    Global.serverObj.send(Global.URL_VUPDATE, null, null, {
      saveType: "360retryClick",
      uniqID: Global.U_ID,
    });
    this.hideScreen();

    Global.collectedTotal = 0;
    Global.itemsCollected.forEach((obj) => {
      obj.item.visible = true;
      obj.item.scale.set(obj.scale.x, obj.scale.y, obj.scale.z);
    });
    Global.itemsCollected = [];

    Global.scenarioItems = {
      conflict: [
        { flak_jacket: 0 },
        { firstaid: 0 },
        { foodpack: 0 },
        { torch: 0 },
        { walkie: 0 },
        { gas_mask: 0 },
        { mic: 0 },
        { tripod: 0 },
        { tent: 0 },
        { sleepy_bag: 0 },
      ],
      cyclone: [
        { life_jacket: 0 },
        { gum_boot: 0 },
        { umbrerlla: 0 },
        { raincoat: 0 },
        { foodpack: 0 },
        { walkie: 0 },
        { battery: 0 },
        { tent: 0 },
        { sleepy_bag: 0 },
        { generator: 0 },
      ],
      remote: [
        { tent: 0 },
        { sleepy_bag: 0 },
        { cookset: 0 },
        { stove: 0 },
        { firstaid: 0 },
        { mosquito: 0 },
        { mic: 0 },
        { walkie: 0 },
        { tripod: 0 },
        { foodpack: 0 },
      ],
    };

    // Global.scenario = shuffle(Object.keys(Global.scenarioItems))[0];
    console.log(Global.scenario);
    const keys = [
      ...new Set(
        Global.scenarioItems[Global.scenario].flatMap((obj) =>
          Object.keys(obj),
        ),
      ),
    ];
    document.querySelector("#scoreScr #tryAgain").classList.remove(`active`);
    document.querySelector("#scoreScr #startNext").classList.remove(`active`);
    this.events.dispatchEvent({
      type: "GAMESCENE_EVENTS",
      message: {
        event_type: "show_screen",
        data: {
          screenKey: "Assignment",
        },
      },
    });
    //
  }

  // async shareThumbnail() {

  //   Global.serverObj.send(Global.URL_VUPDATE, null, null, {
  //     saveType: '360ShareClick',
  //     uniqID: Global.U_ID,
  //   });

  //   this.downloadImage(`https://newsfeedsmartapp.com/BBCFactVsFake/api/uploads/${Global.U_ID}/ThumbnailTemp.jpg`, 'BBC_FactVsFake_Thumbnail.jpg');

  //   try {
  //     const imgURL = `https://newsfeedsmartapp.com/BBCFactVsFake/api/uploads/${Global.U_ID}/ThumbnailTemp.jpg`;

  //     // Fetch image and convert to blob
  //     const response = await fetch(imgURL);
  //     const blob = await response.blob();
  //     const file = new File([blob], "thumbnail.jpg", { type: blob.type });

  //     if (navigator.share) {
  //       try {
  //         // Share
  //         await navigator.share({
  //           files: [file],
  //           // title: "Check this out!",
  //           text: "Sharing the thumbnail image"
  //         });
  //       } catch (err) { }
  //     } else {
  //       location.href = `https://www.facebook.com/sharer/sharer.php?u=${imgURL}`;
  //     }

  //   } catch (err) {
  //     console.log("Sharing failed:", err);
  //   }
  // }

  // downloadBlob(blob, filename) {
  //   const url = URL.createObjectURL(blob);
  //   const a = document.createElement("a");

  //   a.href = url;
  //   a.download = filename;
  //   document.body.appendChild(a);
  //   a.click();

  //   document.body.removeChild(a);
  //   URL.revokeObjectURL(url);
  // }

  async shareImageLink(imgURL) {
    var titletext;
    if (Global.timeTaken < 30) {
      titletext = `ग़ज़ब स्पीड!`;
    } else if (Global.timeTaken >= 30 && Global.timeTaken <= 50) {
      titletext = `काफ़ी फास्ट!`;
    } else {
      titletext = `बढ़िया गेम!`;
    }

    var c = `${titletext} मैंने ${Global.timeTaken} सेकेंड में BBC NEWS GROUND ZERO CHALLENGE पूरा किया. आप भी लीजिए ये चैलेंज… क्लिक करें -`;

    if (navigator.share) {
      await navigator.share({
        text: c,
        url: imgURL,
      });
    } else {
      window.open(
        `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
          imgURL,
        )}`,
        "_blank",
      );
    }
  }

  // async shareThumbnail() {
  //   // const imgURL = `https://newsfeedsmartapp.com/BBCFactVsFake/api/uploads/${Global.U_ID}/ThumbnailTemp.jpg`;
  //   const imgURL = `https://www.bbcnewsgroundzero.com/`;

  //   // 1️⃣ Share LINK (always works)
  //   await this.shareImageLink(imgURL);

  //   // 2️⃣ Download IMAGE
  //   await this.downloadImage(imgURL, "BBC_FactVsFake_Thumbnail.jpg");
  // }

  async shareThumbnail() {
    await this.downloadThenShare();
  }

  async downloadThenShare() {
    // const imgURL = `https://newsfeedsmartapp.com/BBCFactVsFake/api/uploads/${Global.U_ID}/ThumbnailTemp.jpg`;
    const imgURL = `https://www.bbcnewsgroundzero.com/`;
    const filename = "BBC_FactVsFake_Thumbnail.jpg";

    try {
      // 🔹 DOWNLOAD FIRST
      await this.downloadImage(imgURL, filename);

      // 🔹 SMALL DELAY (important for iOS)
      await new Promise((r) => setTimeout(r, 300));

      // 🔹 SHARE LINK (universal & reliable)
      await this.shareImageLink(imgURL);
    } catch (err) {
      console.log("Download or Share failed:", err);
    }
  }

  async downloadImage(url, filename) {
    const response = await fetch(url, { cache: "no-store" });
    const blob = await response.blob();

    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = filename;
    document.body.appendChild(a);
    a.click();

    document.body.removeChild(a);
    URL.revokeObjectURL(a.href);
  }
}
